import { render } from "./PartnerList.vue?vue&type=template&id=0545be8e&scoped=true"
import script from "./PartnerList.vue?vue&type=script&lang=js"
export * from "./PartnerList.vue?vue&type=script&lang=js"

import "./PartnerList.vue?vue&type=style&index=0&id=0545be8e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0545be8e"]])

export default __exports__